providerCallbackController.$inject = [
  "Authentication.providerCallbackServices",
  "$auth",
  "$http",
  "$oidc",
  "$state"
];

function providerCallbackController(providerCallbackServices, auth, http, oidc, state) {

  var self = this;

  http.defaults.headers.common = {};

  self.existsUser = true;
  self.company = {};

  let tinetToken;

  oidc.getUser().then(function (authData) {
    if (authData) {
      let profileInfo = authData.profile;
      self.company.name = authData.profile.name;
      self.company.userName = authData.profile.preferred_username;
      tinetToken = authData.access_token;
      if (authData.profile.user_type == 'Individual') {
        iziToast.show({
          message: 'تنها کاربر حقوقی میتواند در سامانه صندوق ورود کند.',
          theme: "light",
          color: "red"
        });
        oidc.removeUser();
        state.go("Authentication.Login");
      } else if (authData.profile.user_type == 'Legal') {
        existsUser(profileInfo.preferred_username);
      } else {
        auth.signinRedirect();
      }
    } else {
      auth.signinRedirect();
    }
  });

  const customerLogin = function (checkFirstLogin) {
    if (checkFirstLogin == true) {
      location.href = clientFirstLoginUrl;
    } else {
      location.href = clientNormalLoginUrl;
    }
  };

  const getUserLogo = async function (rawResponse) {
    http.defaults.headers.common.Authorization =
      "Bearer " + rawResponse.auth_token;

    let response = rawResponse;

    await providerCallbackServices.getLogo()
      .$promise.then(
        function (responseData) {
          response.logo = responseData.content;
        },
        errResponse => {
          console.log("error");
        }
      )
      .finally(function (res) {
        auth.signIn(response, false);
        customerLogin(response.first_login);
      });

  };

  const existsUser = async function (nationalId) {

    let parameter = {
      type: "Accounts",
      id: nationalId,
      routeParams: "exists"
    }

    await providerCallbackServices.get(parameter).$promise.then(response => {
      registerUser(self.company)
    },
      errResponse => {
        self.existsUser = false;
        console.log("fail PostLoginServices");
      }
    );
  }

  const registerUser = async function (command) {
    http.defaults.headers.common.Authorization = 'Bearer ' + tinetToken;

    let parameter = {
      type: "externalAuth",
      routeParams: "tinet"
    }

    await providerCallbackServices.create(parameter, command).$promise.then(response => {
      getUserLogo(response)
    },
      errResponse => {
        console.log("fail PostLoginServices");
      }
    );
  }

  self.signUpCompany = async function (company, form) {
    if (form.$valid) {
      registerUser(company)
    }
    else {
      iziToast.show({
        message: 'لطفا فرم را تکمیل کنید و سپس اقدام به ثبت فرمایید',
        theme: "light",
        color: "red"
      });
    }
  }

}

module.exports = ngModule => {
  ngModule.controller(
    "Authentication.providerCallbackController",
    providerCallbackController
  );
};
